import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../../actions'
import { Form, FormGroup, FormField, Input, Button, Icon, Divider, Header, Checkbox } from 'semantic-ui-react'

const GameLaunch = ({ supplierName, launchGame }) => {
    const [name, setName] = useState('')
    const [tagline, setTagline] = useState('')
    const [gameCurrency, setGameCurrency] = useState('')
    const [consumerMarkup, setConsumerMarkup] = useState('')
    const [resellerMarkup, setResellerMarkup] = useState({})
    const [resellerMarkupAll, setResellerMarkupAll] = useState('')
    const [setForIndividualReseller, setSetForIndividualReseller] = useState(false)

    const dispatch = useDispatch()
    const resellers = useSelector(state => state.resellers)

    useEffect(() => {
        dispatch(actions.fetchResellers())
    }, [dispatch])

    useEffect(() => {
        var obj = {}
        for (const reseller of resellers) {
            obj[reseller.name] = ''
        }
        setResellerMarkup(obj)
    }, [resellers])

    const handleChangeField = (e) => {
        const { name, value } = e.target
        if (name === 'name') setName(value)
        if (name === 'tagline') setTagline(value)
        if (name === 'gameCurrency') setGameCurrency(value)
        if (name === 'consumerMarkup') setConsumerMarkup(value)
        if (name.includes('resellerMarkup')) setResellerMarkup(getResellerMarkupObject(name.split('-')[1], value))
        if (name === 'resellerMarkupAll') setResellerMarkupAll(value)
    }
    const handleChangeCheckbox = (e, data) => {
        if (data.name === 'setForIndividualReseller') setSetForIndividualReseller(data.checked)
    }

    const getResellerMarkupObject = (name, value) => {
        if (!resellers) return {}
        var obj = { ...resellerMarkup }
        obj[name] = value
        return obj
    }
    const getResellerMarkup = (reseller) => {
        return resellerMarkup[reseller]
    }

    const renderResellerMarkupFields = () => {
        if (!setForIndividualReseller) {
            return <div>
                    <FormField control={Input} label='Reseller Markup %' name='resellerMarkupAll' value={resellerMarkupAll} placeholder='Applies to All Resellers' onChange={handleChangeField} inverted className="dark-theme-input"/>
                    <FormField control={Checkbox} label='Set % for individual resellers' name='setForIndividualReseller' checked={setForIndividualReseller} onChange={handleChangeCheckbox} inverted className="dark-theme-input"/>
                </div>
        } else {
            if (!resellers) return
            const fieldGroups = []
            const resellerFields = []
            for (const reseller of resellers) {
                const nameStr = 'resellerMarkup-' + reseller.name
                const valueStr = getResellerMarkup(reseller.name)
                resellerFields.push(<FormField key={reseller.name} control={Input} label={reseller.name} name={nameStr} value={valueStr} onChange={handleChangeField} className="dark-theme-input"/>)
            }
            for (let i = 0; i < resellerFields.length; i += 3) { // 3 fields per group
                fieldGroups.push(<FormGroup widths="equal" key={`game-group-${i}`}>{resellerFields.slice(i, i + 3)}</FormGroup>)
            }
            return <div>
                <h4 style={{ marginTop: 30 }}>Reseller markup:</h4>
                <FormField control={Checkbox} label='Set % for individual resellers:' name='setForIndividualReseller' checked={setForIndividualReseller} placeholder='' onChange={handleChangeCheckbox} inverted className="dark-theme-input"/>
                {fieldGroups}
            </div>
        }
    }

    return (
        <div style={{ marginTop: 30, border: '1px solid #333', borderRadius: 6, padding: 25 }}>
            <Form inverted>
                <Divider inverted style={{ marginTop: 5, marginBottom: 15 }} horizontal><Header inverted as="h4"><Icon inverted name="game" />Game Details</Header></Divider>
                <FormGroup widths='equal'>
                    <FormField required control={Input} label='Name' name='name' value={name} placeholder='' onChange={handleChangeField} className="dark-theme-input"/>
                    <FormField disabled control={Input} label='Supplier Name' name='supplerName' value={supplierName} className="dark-theme-input"/>
                </FormGroup>
                <FormField control={Input} label='Tagline' name='tagline' value={tagline} placeholder='' onChange={handleChangeField} className="dark-theme-input"/>
                <FormField control={Input} label='Game Currency e.g. Diamonds, Crystals, Onaric Shards' name='gameCurrency' value={gameCurrency} placeholder='Leave blank if the supplier has included it (see above)' onChange={handleChangeField} className="dark-theme-input"/>
                <Divider inverted style={{ marginTop: 35, marginBottom: 15 }} horizontal><Header inverted as="h4"><Icon inverted name="dollar" />Mark up</Header></Divider>
                <FormField control={Input} label='Consumer Markup %' name='consumerMarkup' value={consumerMarkup} placeholder='e.g. 8.8' onChange={handleChangeField} className="dark-theme-input"/>
                {renderResellerMarkupFields()}
                <Button style={{ marginTop: 28 }} inverted color='teal' 
                    onClick={() => launchGame({ name, tagline, gameCurrency, consumerMarkup: Number(consumerMarkup), resellerMarkup: resellerMarkup, resellerMarkupAll: Number(resellerMarkupAll), setForIndividualReseller })}><Icon name='game'/>Launch Game!</Button>
            </Form>
        </div>
    )
}

export default GameLaunch